import Axios from "axios";
import {
  ApiBaseUrl,
  BasicInformationBaseUrl,
  LoanBaseUrl,
} from "../config/config";
import { ApiResultModel } from "../models/common.model";
import {
  GetCitiesRequest,
  GetCitiesResponse,
  GetDocumentTypesResponse,
  GetFactorItemGroupsResponse,
  GetLoanTemplateRequiredAttachmentsTypeForSupplierRequest,
  GetLoanTemplateRequiredAttachmentsTypeForSupplierResponse,
  GetProvincesResponse,
  GetStatusResponse,
} from "../models/basicInformation.model";
import { error } from "console";

export const getLoanRequestStatus = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetLoanRequestStatus"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetSupplierSettlementStatus = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetSupplierSettlementStatus"
  ).then((result) => {
    return result.data.data;
  });
};
export const GetLoanRequestSources = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetLoanRequestSources"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetLoanTemplates = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetLoanTemplates"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetSupplierUsers = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetSupplierUsers"
  ).then((result) => {
    return result.data.data;
  });
};

export const getLoanTemplateRequiredAttachmentsTypeForSupplier = (
  data: GetLoanTemplateRequiredAttachmentsTypeForSupplierRequest
): Promise<GetLoanTemplateRequiredAttachmentsTypeForSupplierResponse[]> => {
  return Axios.post<
    ApiResultModel<GetLoanTemplateRequiredAttachmentsTypeForSupplierResponse[]>
  >(
    ApiBaseUrl +
      BasicInformationBaseUrl +
      "/GetLoanTemplateRequiredAttachmentsTypeForSupplier",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetProvinces = (): Promise<GetProvincesResponse[]> => {
  return Axios.post<ApiResultModel<GetProvincesResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetProvinces"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetCities = (
  data: GetCitiesRequest
): Promise<GetCitiesResponse[]> => {
  return Axios.post<ApiResultModel<GetCitiesResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetCities",
    data
  ).then((result) => {
    return result.data.data;
  });
};

export const GetLoanCancellationReasons = (): Promise<GetStatusResponse[]> => {
  return Axios.get<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetLoanCancellationReasons"
  ).then((result) => {
    return result.data.data;
  });
};

export const GetVehicleTypes = (): Promise<GetStatusResponse[]> => {
  return Axios.post<ApiResultModel<GetStatusResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetVehicleTypes"
  ).then((result) => {
    return result.data.data;
  });
};
export const GetFactorItemGroups = (): Promise<GetFactorItemGroupsResponse[]> => {
  return Axios.post<ApiResultModel<GetFactorItemGroupsResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetFactorItemGroups"
  ).then((result) => {
    return result.data.data;
  });
};
export const getDocumentTypes = (): Promise<GetDocumentTypesResponse[]> => {
  return Axios.get<ApiResultModel<GetDocumentTypesResponse[]>>(
    ApiBaseUrl + BasicInformationBaseUrl + "/GetDocumentTypes"
  ).then((result) => {
    return result.data.data;
  });
};
